<template>
	<div :id="baseId" class="creators-showcase-panel d-flex flex-column">
		<div class="creators-showcase-panel-carousel d-flex flex-column">
			<div class="slide_header">
				<h1>The Best Creators Use Stan 🚀</h1>
				<h2>See how our Creators use Stan to superpower their businesses!</h2>
			</div>
			<div class="scroller" ref="scroller" @mouseenter="toggleScrolling(false)" @mouseleave="toggleScrolling(true)">
				<ul class="scroll__inner" ref="scrollerInner">
					<li class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/abi.png') + ')' }">
							<div class="expo anim">
								<h1>Abigail Peugh</h1>
								<h2>@abigailpeugh</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
									<h4>100K+ Followers</h4>
								</div>
								<h3>💰 <span>.</span> Business Coach</h3>
							</div>
						</div>
						<a href="https://stan.store/abigailpeugh" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-abi.png" alt="store" />
						</a>
					</li>

					<li class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/millie.jpg') + ')' }">
							<div class="expo anim">
								<h1>Millie Adrian</h1>
								<h2>@itsmodernmillie</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
									<h4>150K+ Followers</h4>
								</div>
								<h3>📲 <span>.</span> Social Media Coach</h3>
							</div>
						</div>
						<a href="https://stan.store/itsmodernmillie" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-millie.png" alt="store" />
						</a>
					</li>

					<div class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/eddie.png') + ')' }">
							<div class="expo anim">
								<h1>Eddie Abbew</h1>
								<h2>@eddieabbew</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
									<h4>554K+ Followers</h4>
								</div>
								<h3>💪 <span>.</span> Fitness Coach</h3>
							</div>
						</div>
						<a href="https://stan.store/eddieabbew" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/store-eddie.svg" alt="store" />
						</a>
					</div>

					<li class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/priest.png') + ')' }">
							<div class="expo anim">
								<h1>Sarah Perl</h1>
								<h2>@hothighpriestess</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
									<h4>2.4M+ Followers</h4>
								</div>
								<h3>✨ <span>.</span> Spirituality Creator</h3>
							</div>
						</div>
						<a href="https://stan.store/hothighpriestess" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-priestess.png" alt="store" />
						</a>
					</li>

					<li class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/tat.jpg') + ')' }">
							<div class="expo anim">
								<h1>Tatiana Londono</h1>
								<h2>@tatlondono</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/tt.svg" alt="Instagram" />
									<h4>2.8M+ Followers</h4>
								</div>
								<h3>🏠 <span>.</span> Real Estate Coach</h3>
							</div>
						</div>
						<a href="https://www.tiktok.com/@tatlondono" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-tat.png" alt="profile" />
						</a>
					</li>

					<li class="highlight">
						<div class="img" :style="{ 'background-image': 'url(' + require('@/assets/images/home/v6/thea.webp') + ')' }">
							<div class="expo anim">
								<h1>Thea Wayne</h1>
								<h2>@moneyhealingclub</h2>
								<div class="social">
									<img src="@/assets/images/home/v6/ig.svg" alt="Instagram" />
									<h4>3K+ Followers</h4>
								</div>
								<h3>💰 <span>.</span> Finance Coach</h3>
							</div>
						</div>
						<a href="https://www.tiktok.com/@moneyhealingclub" class="offset" target="_blank">
							<img class="store anim" src="@/assets/images/home/v6/creatorHighlights/store-healing.png" alt="profile" />
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed, defineProps, onMounted, ref } from 'vue'

	const props = defineProps({
		id: {
			type: [String, Number],
		},
		activeComponent: { type: Boolean },
	})

	const baseId = computed(() => `${props.id}`)
	const scroller = ref()
	const scrollerInner = ref()

	onMounted(() => {
		if (true) {
			addAnimation()
		}
	})


	function addAnimation() {
		scroller.value?.setAttribute('data-animated', true)
		const scrollerChildren = Array.from(scrollerInner.value.children)
		scrollerChildren.forEach(item => {
			const duplicateItem = item.cloneNode(true)
			duplicateItem.setAttribute('aria-hidden', true)
			scrollerInner.value.appendChild(duplicateItem)
		})
	}
	function toggleScrolling(keepScrolling) {
		scroller.value?.setAttribute('data-animated', keepScrolling)
	}

</script>

<style lang="scss" scoped>
	.creators-showcase-panel {
		background: white;
		padding-top: 30px;
		position: relative;
	}


	.highlight {
		display: flex;
		align-items: center;

		&:nth-child(even) {
			transform: translateY(var(--parallax-s1-1));
		}

		&:nth-child(odd) {
			transform: translateY(var(--parallax-s1-2));
		}

		&.final {
			padding-right: 100px;
		}

		.img {
			height: 400px;
			width: 400px;
			border-radius: 15px;
			box-shadow: -10px 10px 30px rgba(black, 0.1);
			background-position: center center;
			background-size: cover;
			position: relative;
		}
		.expo {
			position: absolute;
			bottom: 0;
			left: 0;
			color: white;
			border-radius: 15px;
			width: 340px;
			padding: 25px;
			background-image: linear-gradient(to top, rgba(black, 0.7), rgba(black, 0));

			.social {
				display: flex;
				align-items: center;
				gap: 6px;
				margin-left: 1px;
				margin-bottom: 12px;
				img {
					height: 13px;
				}
				h4 {
					color: white;
					font-weight: 500;
					font-size: 12px;
					line-height: 10px;
					margin-top: 7px;
				}
			}

			h1 {
				font-size: 24px;
				font-weight: 700;
				margin-bottom: 6px;
				text-shadow: 0px 20px 30px rgba(black, 0.9);
			}

			h2 {
				font-size: 14px;
				font-weight: 500;
				color: rgba(white, 0.6);
				margin-bottom: 6px;
				text-shadow: 0px 20px 30px rgba(black, 0.9);
			}

			h3 {
				font-size: 13px;
				font-weight: 700;
				background: white;
				color: black;
				padding: 10px 13px;
				width: fit-content;
				border-radius: 50px;

				span {
					color: white;
				}
			}
		}
	}

	.profile {
		width: 230px;
		border-radius: 20px;
		box-shadow: 0px 20px 60px rgba(#00106d, 0.1);
	}
	.store {
		width: 220px;
		border-radius: 40px;
		box-shadow: -10px 10px 30px rgba(black, 0.1);
		z-index: 5 !important;
		transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
	}
	.offset {
		transform: translateX(-100px);
	}
	.offset :hover {
		transform: scale(1.02);
	}
	.slide_highlight {
		padding-bottom: 0;
		background-color: none;
	}

	.slide_carousel {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		background: none;
		padding: 120px 0;
		gap: 50px;

		.stat {
			width: 240px !important;
			height: 240px !important;
			background: #f5f5f5;
			border-radius: 50%;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			&:nth-child(1) {
				transform: translateY(var(--parallax-s3-1));
			}

			&:nth-child(2) {
				transform: translateY(var(--parallax-s3-2));
			}

			&:nth-child(3) {
				transform: translateY(var(--parallax-s3-2));
			}

			&.big {
				width: 280px !important;
				height: 280px !important;
			}

			h1 {
				font-size: 80px;
				font-weight: 900;
				margin: 0;
			}

			h2 {
				font-size: 40px;
				font-weight: 900;
				margin: 0;
			}

			h3 {
				font-size: 16px;
				font-weight: 400;
				letter-spacing: -0.2px;
				margin: 0;
				margin-top: 15px;
			}
		}
	}

	@media screen and (max-width: 767px) {

		.creators-showcase-panel{
			margin-bottom: -32px;
		}

		.slide_header{
			padding: 0;
		}

		.slide_carousel {
			display: flex;
			flex-direction: column;
			padding: 0;
		}
	}

	@media screen and (max-width: 767px) {
		.scroll {
			padding-left: 80px !important;

		}
		.highlight {
			margin-left: -50px;
			.expo {
				width: 70vw;
				padding: 20px;
			}
			.img {
				width: 70vw;
				height: 70vw;
				.expo {
					padding: 20px;
					h1 {
						font-size: 22px;
						margin-bottom: 5px;
					}
					h2 {
						margin-bottom: 10px;
					}
				}
			}
			.store {
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
			}
		}
	}

	.scroller {
		max-width: 90%;
		overflow-y: hidden;
		position: relative;
		transform: translateX(-50%);
		left: 50%;
	}

	.scroller {
		-webkit-mask: linear-gradient(90deg, transparent, white 10%, white 90%, transparent);
		mask: linear-gradient(90deg, transparent, white 10%, white 90%, transparent);
	}

	.scroller .scroll__inner {
		width: max-content;
		animation: scroll 60s linear infinite;
		animation-play-state: paused; /* Start paused */
	}

	.scroller[data-animated='true'] .scroll__inner {
		animation-play-state: running; /* Resume when the element is in view */
	}

	.scroll__inner {
		display: flex;
		gap: 0px;
		padding: 80px 30px 60px 100px;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	.scroll__inner::-webkit-scrollbar {
		display: none;
	}

	@keyframes scroll {
		to {
			transform: translate(calc(-50% + 67px));
		}
	}

	@media screen and (max-width: 800px){
		.slide_carousel{
			padding: 32px 0;
		}
	}

</style>
